// Centralized blog data repository for Codewave

import bulksms from '../assets/Bulk-sms-provider-kenya.jpg';
import ussd from '../assets/ussd-mobipesa-kenya.jpg';
import callcenter from '../assets/call-center.jpg';
import securepayment from '../assets/secure-payment-blog.jpg';
import softwareblog from '../assets/software-blogs.jpg';
import apiintergration from '../assets/api-intergration-blogs.jpg';
import digitalcommunication from '../assets/digital-comm.jpg';
import digitalpayment from '../assets/digital payment.png';
import ussdblog from '../assets/ussd background.png';
import callcenterblog from '../assets/call-center-blog.jpg';
import softwarehero from '../assets/software-hero.jpg';

// Blog categories
export const blogCategories = [
  { id: 'all', name: 'All Posts' },
  { id: 'sms', name: 'Bulk SMS' },
  { id: 'ussd', name: 'USSD Services' },
  { id: 'call-center', name: 'Call Center' },
  { id: 'payments', name: 'Payments' },
  { id: 'software', name: 'Software Dev' }
];

// Helper function to get category name
export const getCategoryName = (categoryId) => {
  const category = blogCategories.find(cat => cat.id === categoryId);
  return category ? category.name : categoryId;
};

// Main blog posts data
export const blogPosts = [
  {
    id: 1,
    title: "5 Ways Bulk SMS Can Transform Your Customer Engagement",
    excerpt: "Discover how bulk SMS solutions can significantly improve your customer interactions, increase response rates, and drive business growth.",
    category: "sms",
    date: "June 8, 2023",
    author: "Janice Anyula",
    authorImage: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
    authorBio: "Janice is a Senior Marketing Strategist at Codewave with over 8 years of experience in digital marketing and customer engagement strategies.",
    image: bulksms,
    featured: true,
    tags: ["SMS Marketing", "Customer Engagement", "Conversion", "ROI", "Communication"],
    content: `
      <p>In today's fast-paced digital world, businesses are constantly searching for effective ways to engage with their customers. While email marketing and social media have become standard practice, bulk SMS remains one of the most powerful yet underutilized communication channels for businesses.</p>
      
      <p>With open rates exceeding 98% and most messages read within minutes of receipt, SMS offers unparalleled reach and immediacy. Here are five ways bulk SMS can transform your customer engagement strategy:</p>
      
      <h2>1. Immediate Communication with Near-Perfect Delivery</h2>
      
      <p>Unlike emails that might get lost in crowded inboxes or social media posts that can be buried in algorithms, SMS messages are delivered directly to your customers' most personal device – their mobile phones. Studies show that 90% of text messages are read within the first three minutes of delivery.</p>
      
      <p>This immediacy makes SMS ideal for time-sensitive communications such as:</p>
      
      <ul>
        <li>Flash sales and limited-time offers</li>
        <li>Appointment reminders</li>
        <li>Service updates</li>
        <li>Important announcements</li>
      </ul>
      
      <p>By leveraging this direct channel, businesses can ensure their critical messages reach customers in real-time, driving faster responses and actions.</p>
      
      <h2>2. Personalized Customer Experiences</h2>
      
      <p>Modern bulk SMS platforms allow for sophisticated personalization that goes far beyond simply addressing customers by name. With the right customer data integration, your SMS campaigns can deliver highly relevant content based on:</p>
      
      <ul>
        <li>Past purchase history</li>
        <li>Location data</li>
        <li>Customer preferences</li>
        <li>Behavioral triggers</li>
      </ul>
      
      <p>For example, a retail business can send personalized product recommendations based on previous purchases, or a restaurant can send special offers on a customer's favorite dishes. This level of personalization significantly improves engagement rates and strengthens customer relationships.</p>
      
      <h2>3. Enhanced Customer Service</h2>
      
      <p>SMS isn't just for marketing – it's also a powerful customer service tool. Implementing two-way SMS communication allows customers to get immediate assistance without the frustration of waiting on hold or navigating complex phone menus.</p>
      
      <p>Some effective customer service applications include:</p>
      
      <ul>
        <li>Order status updates</li>
        <li>Delivery tracking</li>
        <li>Quick support queries</li>
        <li>Feedback collection</li>
      </ul>
      
      <p>Businesses using SMS for customer service often report higher satisfaction rates and improved customer retention as issues can be resolved quickly and efficiently.</p>
      
      <h2>4. Seamless Integration with Other Marketing Channels</h2>
      
      <p>Bulk SMS doesn't operate in isolation—it works best as part of an integrated marketing strategy. SMS can complement and enhance other marketing channels in several ways:</p>
      
      <ul>
        <li>Following up on email campaigns with SMS reminders</li>
        <li>Sending SMS alerts about new social media content</li>
        <li>Delivering QR codes that link to more detailed online content</li>
        <li>Providing quick updates between more comprehensive communications</li>
      </ul>
      
      <p>This multi-channel approach ensures your message reaches customers through their preferred communication methods while providing consistent messaging across all touchpoints.</p>
      
      <h2>5. Measurable Results and High ROI</h2>
      
      <p>One of the most compelling advantages of bulk SMS marketing is its measurability and impressive return on investment. Modern SMS platforms provide detailed analytics on:</p>
      
      <ul>
        <li>Delivery rates</li>
        <li>Open rates</li>
        <li>Click-through rates</li>
        <li>Conversion tracking</li>
      </ul>
      
      <p>With average response rates between 30-45% (compared to email's 5-10%), SMS campaigns typically deliver exceptional ROI. The cost per message is relatively low, making it accessible for businesses of all sizes.</p>
      
      <h2>Conclusion</h2>
      
      <p>In a world where consumer attention is increasingly fragmented, bulk SMS offers businesses a direct line to their customers' pockets. Its unmatched open rates, personalization capabilities, and integration potential make it an essential component of any comprehensive customer engagement strategy.</p>
      
      <p>By implementing these five strategies, your business can leverage the power of SMS to build stronger customer relationships, drive higher engagement, and ultimately increase revenue. The key is to use SMS thoughtfully, respecting customer preferences and delivering genuine value with each message.</p>
      
      <p>Ready to transform your customer engagement with bulk SMS? Contact our team at Codewave today to learn more about our comprehensive SMS solutions tailored to your business needs.</p>
    `
  },
  {
    id: 2,
    title: "The Evolution of USSD Services in African Markets",
    excerpt: "Learn about the growth and development of USSD services across African markets and how businesses are leveraging this technology for success.",
    category: "ussd",
    date: "May 22, 2023",
    author: "Daniel Ochieng",
    authorImage: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
    authorBio: "Daniel is a Technology Consultant at Codewave specializing in USSD and mobile payment solutions across African markets.",
    image: ussd,
    featured: false,
    tags: ["USSD", "Mobile Technology", "Africa", "Banking", "Digital Services"],
    content: `
      <p>USSD (Unstructured Supplementary Service Data) has been a cornerstone of mobile communication in Africa for over two decades. This simple yet powerful technology has evolved significantly, becoming an essential tool for businesses and financial institutions across the continent.</p>
      
      <h2>The Early Days of USSD in Africa</h2>
      
      <p>USSD first gained prominence in Africa during the early 2000s when mobile penetration was growing rapidly but internet connectivity remained limited. Banks and mobile operators quickly recognized its potential for providing basic services without requiring internet access.</p>
      
      <h2>Current Applications and Success Stories</h2>
      
      <p>Today, USSD services in Africa have expanded far beyond basic banking. They now include:</p>
      
      <ul>
        <li>Mobile money transfers and payments</li>
        <li>Agricultural information services</li>
        <li>Healthcare appointment booking</li>
        <li>Educational content delivery</li>
        <li>Government service access</li>
      </ul>
      
      <p>The technology continues to play a vital role in financial inclusion and digital transformation across the continent.</p>
    `
  },
  {
    id: 3,
    title: "Building Effective Call Center Solutions for Small Businesses",
    excerpt: "Small businesses can now access enterprise-level call center capabilities. Here's how to implement cost-effective solutions for your company.",
    category: "call-center",
    date: "May 15, 2023",
    author: "Amina Hassan",
    authorImage: "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
    authorBio: "Amina is a Customer Experience Specialist at Codewave with expertise in call center optimization and customer service automation.",
    image: callcenter,
    featured: false,
    tags: ["Call Center", "Customer Service", "Small Business", "Automation", "Customer Experience"],
    content: `
      <p>Call centers are no longer the exclusive domain of large corporations. With modern technology, small businesses can now implement sophisticated call center solutions that rival those of enterprise organizations.</p>
      
      <h2>Key Components of Modern Call Center Solutions</h2>
      
      <p>Effective call center solutions for small businesses typically include:</p>
      
      <ul>
        <li>Cloud-based phone systems</li>
        <li>Call routing and queuing</li>
        <li>Customer relationship management integration</li>
        <li>Analytics and reporting tools</li>
        <li>Multi-channel support capabilities</li>
      </ul>
      
      <p>These features help small businesses provide professional customer service while maintaining cost efficiency.</p>
    `
  },
  {
    id: 4,
    title: "Secure Payment Solutions: What You Need to Know",
    excerpt: "Security should be your top priority when choosing payment solutions. This article explores best practices for maintaining secure transactions.",
    category: "payments",
    date: "May 3, 2023",
    author: "John Kamau",
    authorImage: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
    authorBio: "John is a Security Expert at Codewave focusing on payment security, fraud prevention, and compliance standards.",
    image: securepayment,
    featured: true,
    tags: ["Payment Security", "Fraud Prevention", "Compliance", "PCI DSS", "Encryption"],
    content: `
      <p>In today's digital economy, secure payment processing is not just a feature—it's a fundamental requirement for any business handling financial transactions.</p>
      
      <h2>Essential Security Measures</h2>
      
      <p>Modern payment solutions must implement several layers of security:</p>
      
      <ul>
        <li>End-to-end encryption</li>
        <li>Tokenization of sensitive data</li>
        <li>Multi-factor authentication</li>
        <li>Real-time fraud detection</li>
        <li>PCI DSS compliance</li>
      </ul>
      
      <p>These measures work together to protect both businesses and customers from potential security threats.</p>
    `
  },
  {
    id: 5,
    title: "Custom Software Development Trends for 2023",
    excerpt: "Stay ahead of the curve with these emerging trends in custom software development that are shaping how businesses operate in 2023.",
    category: "software",
    date: "April 27, 2023",
    author: "Grace Wanjiru",
    authorImage: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
    authorBio: "Grace is a Senior Software Developer at Codewave with expertise in modern development frameworks and emerging technologies.",
    image: softwareblog,
    featured: false,
    tags: ["Software Development", "Technology Trends", "Custom Solutions", "Digital Transformation", "Innovation"],
    content: `
      <p>The software development landscape is constantly evolving, with new technologies and methodologies emerging regularly. Staying current with these trends is crucial for businesses looking to maintain competitive advantages.</p>
      
      <h2>Key Trends Shaping Software Development</h2>
      
      <p>Several trends are currently influencing custom software development:</p>
      
      <ul>
        <li>Low-code and no-code platforms</li>
        <li>Microservices architecture</li>
        <li>Artificial intelligence integration</li>
        <li>Progressive web applications</li>
        <li>DevOps and continuous deployment</li>
      </ul>
      
      <p>These trends are enabling faster development cycles and more sophisticated applications.</p>
    `
  },
  {
    id: 6,
    title: "Integration Strategies: Connecting SMS with Your Existing Systems",
    excerpt: "Learn how to seamlessly integrate SMS capabilities with your current software systems for enhanced functionality and efficiency.",
    category: "sms",
    date: "April 18, 2023",
    author: "Michael Ochieng",
    authorImage: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
    authorBio: "Michael is an Integration Specialist at Codewave, helping businesses connect SMS services with their existing infrastructure.",
    image: apiintergration,
    featured: false,
    tags: ["API Integration", "SMS", "System Integration", "Automation", "Workflow"],
    content: `
      <p>Successful SMS integration requires careful planning and understanding of your existing systems. The right integration strategy can transform how your business communicates with customers.</p>
      
      <h2>Integration Approaches</h2>
      
      <p>There are several ways to integrate SMS capabilities:</p>
      
      <ul>
        <li>REST API integration</li>
        <li>Webhook implementations</li>
        <li>Database triggers</li>
        <li>Third-party platform connectors</li>
        <li>Custom middleware solutions</li>
      </ul>
      
      <p>Each approach offers different benefits depending on your specific requirements and existing infrastructure.</p>
    `
  },
  {
    id: 7,
    title: "The Future of Digital Communication in Africa",
    excerpt: "Africa is seeing unprecedented growth in digital communication. Learn about the trends shaping the future of connectivity on the continent.",
    category: "ussd",
    date: "April 10, 2023",
    author: "Jane Muthoni",
    authorImage: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
    authorBio: "Jane is a Senior Marketing Strategist at Codewave with over 8 years of experience in digital marketing and customer engagement strategies.",
    image: digitalcommunication,
    featured: false,
    tags: ["Digital Communication", "Africa", "Technology Trends", "Connectivity", "Innovation"],
    content: `
      <p>Africa's digital landscape is evolving rapidly, with new technologies and communication methods emerging to meet the continent's unique challenges and opportunities.</p>
      
      <h2>Emerging Trends</h2>
      
      <p>Key developments shaping Africa's digital future include:</p>
      
      <ul>
        <li>Increased mobile penetration</li>
        <li>5G network expansion</li>
        <li>Fintech innovation</li>
        <li>Local content creation</li>
        <li>Digital literacy programs</li>
      </ul>
      
      <p>These trends are creating new opportunities for businesses and consumers alike.</p>
    `
  },
  {
    id: 8,
    title: "Improving Customer Service with Automated SMS Responses",
    excerpt: "How automated SMS responses can streamline your customer service operations while maintaining a personal touch in communications.",
    category: "sms",
    date: "April 5, 2023",
    author: "Daniel Ochieng",
    authorImage: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
    authorBio: "Daniel is a Technology Consultant at Codewave specializing in USSD and mobile payment solutions across African markets.",
    image: apiintergration,
    featured: false,
    tags: ["Automation", "Customer Service", "SMS", "Efficiency", "Personalization"],
    content: `
      <p>Automated SMS responses can significantly improve customer service efficiency while maintaining the personal touch that customers expect.</p>
      
      <h2>Benefits of SMS Automation</h2>
      
      <p>Automated SMS systems offer several advantages:</p>
      
      <ul>
        <li>24/7 availability</li>
        <li>Consistent response times</li>
        <li>Scalability</li>
        <li>Cost reduction</li>
        <li>Improved customer satisfaction</li>
      </ul>
      
      <p>When implemented correctly, automation can enhance rather than replace human interaction.</p>
    `
  },
  {
    id: 9,
    title: "Building Reliable Payment Infrastructure for Small Businesses",
    excerpt: "Small businesses need reliable payment systems to thrive. Discover how to set up robust payment infrastructure with minimal investment.",
    category: "payments",
    date: "March 29, 2023",
    author: "John Kamau",
    authorImage: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
    authorBio: "John is a Security Expert at Codewave focusing on payment security, fraud prevention, and compliance standards.",
    image: digitalpayment,
    featured: false,
    tags: ["Payment Infrastructure", "Small Business", "Reliability", "Cost-Effective", "Security"],
    content: `
      <p>Reliable payment infrastructure is essential for small business success. Modern solutions make it possible to build robust systems without massive upfront investments.</p>
      
      <h2>Essential Components</h2>
      
      <p>A reliable payment infrastructure should include:</p>
      
      <ul>
        <li>Multiple payment methods</li>
        <li>Secure processing</li>
        <li>Real-time reporting</li>
        <li>Error handling</li>
        <li>Backup systems</li>
      </ul>
      
      <p>These components work together to ensure smooth payment operations.</p>
    `
  },
  {
    id: 10,
    title: "The Role of USSD in Banking Services",
    excerpt: "USSD continues to be a critical technology for banking services in regions with limited internet connectivity. Here's why it remains relevant.",
    category: "ussd",
    date: "March 20, 2023",
    author: "Amina Hassan",
    authorImage: "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
    authorBio: "Amina is a Customer Experience Specialist at Codewave with expertise in call center optimization and customer service automation.",
    image: ussdblog,
    featured: false,
    tags: ["USSD", "Banking", "Financial Services", "Mobile Banking", "Accessibility"],
    content: `
      <p>Despite the rise of mobile apps and internet banking, USSD remains a vital technology for banking services, especially in areas with limited internet connectivity.</p>
      
      <h2>Why USSD Endures</h2>
      
      <p>USSD continues to be relevant for several reasons:</p>
      
      <ul>
        <li>Works without internet</li>
        <li>Universal compatibility</li>
        <li>Low cost</li>
        <li>Reliable delivery</li>
        <li>Wide accessibility</li>
      </ul>
      
      <p>These factors make USSD an essential tool for financial inclusion.</p>
    `
  },
  {
    id: 11,
    title: "Choosing the Right Call Center Software",
    excerpt: "With so many options available, selecting the right call center software can be challenging. Use these criteria to make an informed decision.",
    category: "call-center",
    date: "March 15, 2023",
    author: "Grace Wanjiru",
    authorImage: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
    authorBio: "Grace is a Senior Software Developer at Codewave with expertise in modern development frameworks and emerging technologies.",
    image: callcenterblog,
    featured: false,
    tags: ["Call Center Software", "Selection Criteria", "Technology", "Business Tools", "Customer Service"],
    content: `
      <p>Selecting the right call center software is crucial for business success. The choice can significantly impact customer satisfaction and operational efficiency.</p>
      
      <h2>Selection Criteria</h2>
      
      <p>Consider these factors when choosing call center software:</p>
      
      <ul>
        <li>Scalability</li>
        <li>Integration capabilities</li>
        <li>Reporting features</li>
        <li>Cost-effectiveness</li>
        <li>User experience</li>
      </ul>
      
      <p>These criteria help ensure you choose a solution that grows with your business.</p>
    `
  },
  {
    id: 12,
    title: "Custom vs. Off-the-shelf Software Solutions",
    excerpt: "Should you invest in custom software or use an existing solution? This guide helps you make the right choice for your business needs.",
    category: "software",
    date: "March 8, 2023",
    author: "Michael Ochieng",
    authorImage: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
    authorBio: "Michael is an Integration Specialist at Codewave, helping businesses connect SMS services with their existing infrastructure.",
    image: softwarehero,
    featured: false,
    tags: ["Custom Software", "Off-the-shelf", "Decision Making", "Business Strategy", "Technology Investment"],
    content: `
      <p>The choice between custom and off-the-shelf software is one of the most important decisions businesses face when implementing technology solutions.</p>
      
      <h2>Factors to Consider</h2>
      
      <p>When making this decision, consider:</p>
      
      <ul>
        <li>Budget constraints</li>
        <li>Time requirements</li>
        <li>Specific business needs</li>
        <li>Scalability requirements</li>
        <li>Maintenance capabilities</li>
      </ul>
      
      <p>Each approach has its advantages depending on your specific circumstances.</p>
    `
  }
];

// Helper functions
export const getFeaturedPosts = () => {
  return blogPosts.filter(post => post.featured);
};

export const getPostsByCategory = (categoryId) => {
  if (categoryId === 'all') return blogPosts;
  return blogPosts.filter(post => post.category === categoryId);
};

export const getPostById = (postId) => {
  return blogPosts.find(post => post.id === parseInt(postId));
};

export const getRelatedPosts = (currentPostId, category, limit = 3) => {
  const currentPost = getPostById(currentPostId);
  if (!currentPost) return [];
  
  return blogPosts
    .filter(post => post.id !== parseInt(currentPostId))
    .filter(post => post.category === category || post.category === currentPost.category)
    .slice(0, limit);
};

export const searchPosts = (query) => {
  const searchTerm = query.toLowerCase();
  return blogPosts.filter(post => 
    post.title.toLowerCase().includes(searchTerm) || 
    post.excerpt.toLowerCase().includes(searchTerm) ||
    post.category.toLowerCase().includes(searchTerm) ||
    post.author.toLowerCase().includes(searchTerm) ||
    post.tags.some(tag => tag.toLowerCase().includes(searchTerm))
  );
};

export const getRecentPosts = (limit = 4) => {
  return blogPosts
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, limit);
};

export const getPostsByTag = (tag) => {
  const searchTerm = tag.toLowerCase();
  return blogPosts.filter(post => 
    post.tags.some(tag => tag.toLowerCase().includes(searchTerm))
  );
};

export default {
  blogPosts,
  blogCategories,
  getCategoryName,
  getFeaturedPosts,
  getPostsByCategory,
  getPostById,
  getRelatedPosts,
  searchPosts,
  getRecentPosts,
  getPostsByTag
}; 
